import React from 'react';
import { Field } from 'redux-form';
import {
  Accordion,
  Button,
  Divider,
  Form,
  Grid,
  Icon,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { InputField, DatePickerField } from 'Common/SemanticWrapper';
import { DatePickerCustomButton } from 'Components';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { SiteComponent } from 'Common/SiteComponent';
import { CreateEditPrepWorksheetEnum } from 'Common/FieldEnum';
import { SiteTypeEnum } from 'Common/Constants/Enumeration/SiteTypeEnum';

import { KitchenPrepWorksheetInfo } from './../../containers/createEditKitchenPrepWorksheet/KitchenPrepWorksheetInfo';

const CreateEditKitchenPrepWorksheetComponent = props => {
  const {
    activeIndexForFilter,
    handleClick,
    sorted,
    onSortedChange,
    filtered,
    onFilteredChange,
    page,
    onPageChange,
    dropDownChange,
    clearFilters,
    kitchenItems,
    onChangeOfDeliveryDT,
    loading,
    disabled,
    isEditDisabled,
  } = props;

  return (
    <Form>
      <Accordion fluid styled>
        <Accordion.Title
          active={!activeIndexForFilter}
          index={0}
          onClick={handleClick}
        >
          <Icon name="dropdown" />
          <span className="text-orange">Filter By</span>
        </Accordion.Title>
        <Accordion.Content active={!activeIndexForFilter}>
          <Grid className="grid-spacing">
            <Grid.Row columns={4}>
              <Grid.Column>
                <Field
                  component={DatePickerField}
                  customInput={
                    <DatePickerCustomButton
                      isDisabled={disabled || isEditDisabled}
                    />
                  }
                  label={'Delivery Date'}
                  dateFormat={DATE_FORMAT_FOR_UI}
                  name={CreateEditPrepWorksheetEnum.DeliveryDT}
                  onChange={onChangeOfDeliveryDT}
                  type={'text'}
                  dropdownMode="select"
                />
              </Grid.Column>
              <Grid.Column>
                <SiteComponent
                  label={'Kitchen'}
                  name={CreateEditPrepWorksheetEnum.Kitchen}
                  onChange={dropDownChange}
                  isForm={true}
                  siteMasterTypeIds={[SiteTypeEnum.Kitchen]}
                  style={{ marginBottom: 10 }}
                  checkIsLicensed={false}
                  isAllRequired={false}
                  disabled={disabled || isEditDisabled}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name={CreateEditPrepWorksheetEnum.Comments}
                  component={InputField}
                  type="text"
                  maxLength={50}
                  label={'Comments'}
                  disabled={disabled}
                />
              </Grid.Column>
              <Grid.Column
                floated={'right'}
                textAlign={'right'}
                style={{
                  marginTop: 35,
                }}
              >
                <Button
                  content="Clear Filters"
                  onClick={clearFilters}
                  type={'button'}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Accordion.Content>
      </Accordion>
      <Divider horizontal />
      <Grid>
        <Grid.Row columns={1} className={'remove-spacing'}>
          <Grid.Column>
            <Field
              component={KitchenPrepWorksheetInfo}
              name={CreateEditPrepWorksheetEnum.KitchenPrepWorksheetInfo}
              {...{
                dataSource: kitchenItems,
                sorted,
                onSortedChange,
                filtered,
                onFilteredChange,
                page,
                onPageChange,
                negativeQuantityAllowed: true,
                loading,
              }}
              disabled={disabled}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

CreateEditKitchenPrepWorksheetComponent.propTypes = {
  activeIndexForFilter: PropTypes.number,
  handleClick: PropTypes.func,
  sorted: PropTypes.array,
  onSortedChange: PropTypes.func,
  filtered: PropTypes.array,
  onFilteredChange: PropTypes.func,
  page: PropTypes.number,
  onPageChange: PropTypes.func,
  dropDownChange: PropTypes.func,
  clearFilters: PropTypes.func,
  kitchenItems: PropTypes.array,
  onChangeOfDeliveryDT: PropTypes.func,
  handleShowWarningBeforeSave: PropTypes.func,
  neededQtyDiff: PropTypes.array,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  isEditDisabled: PropTypes.bool,
};

CreateEditKitchenPrepWorksheetComponent.defaultProps = {
  activeIndexForFilter: 0,
  handleClick: () => {},
  sorted: [],
  onSortedChange: () => {},
  filtered: [],
  onFilteredChange: () => {},
  page: 0,
  onPageChange: () => {},
  dropDownChange: () => {},
  clearFilters: () => {},
  onChangeOfDeliveryDT: () => {},
  handleShowWarningBeforeSave: () => {},
  neededQtyDiff: [],
  loading: false,
  disabled: false,
  isEditDisabled: false,
  kitchenItems: [],
};

export default CreateEditKitchenPrepWorksheetComponent;



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/components/createEditKitchenPrepWorksheet/CreateEditKitchenPrepWorksheet.js